<template>
  <div v-if="clientPortal != null" id="show-client-portal-background">
    <div>
      <v-dialog v-model="dialogForBackground" persistent max-width="300">
        <template v-slot:activator="{ on }">
          <v-btn v-if="isGrantedUser()" v-on="on" text :loading="loading">
            <v-icon left>mdi-upload</v-icon>
            Charger
          </v-btn>
          <v-btn
            v-if="isGrantedUser()"
            :disabled="!hasResource"
            text
            @click="openDeleteDialog(clientPortal)"
            :loading="loading"
          >
            <v-icon left>mdi-delete</v-icon>
            Supprimer
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="primary-background">
            <span>Chargement du fond</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="backgroundFormRef" v-model="isFormValid">
              <v-file-input
                :rules="background_fileRules"
                v-model="backgroundFile"
                label="Fond"
                accept=".jpg, .png, .svg"
              ></v-file-input>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogForBackground = false">
              Fermer
            </v-btn>
            <v-btn
              color="primary"
              @click="triggerUploadBackground"
              :loading="uploadLoading"
              :disabled="!isFormValid"
            >
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <delete-dialog
      :open.sync="deleteDialog"
      v-on:delete="triggerRemoveBackground"
    >
      <template #title>
        Suppression du fond pour {{ clientPortal.description }}
      </template>
      Vous êtes sur le point de supprimer le fond de ce portail. Voulez-vous
      continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { useClientPortalBackground } from "../../composables/client-portal-background";
import { toRefs, computed, ref } from "@vue/composition-api";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    clientPortal: Object,
  },
  components: {
    DeleteDialog,
  },
  setup(props, { emit }) {
    const {
      clientPortalBackgroundData,
      uploadBackground,
      removeBackground,
    } = useClientPortalBackground();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const loading = ref(false);
    const errorMessage = ref("");
    const uploadLoading = ref(false);
    const isFormValid = ref(false);

    /* Computed */
    const hasResource = computed(function () {
      return props.clientPortal.backgroundPath.indexOf("/background") > -1;
    });

    /* Méthodes */
    const openDeleteDialog = function (portal) {
      clientPortalBackgroundData.deleteDialog = true;
      clientPortalBackgroundData.editedItem = { ...portal };
    };
    const closeDeleteDialog = function () {
      clientPortalBackgroundData.deleteDialog = false;
      clientPortalBackgroundData.editedItem = null;
    };
    const triggerRemoveBackground = async function () {
      loading.value = true;
      await removeBackground(clientPortalBackgroundData.editedItem.id);
      loading.value = false;
      closeDeleteDialog();
      emit("refresh-preview");
    };
    const triggerUploadBackground = async function () {
      uploadLoading.value = true;
      await uploadBackground(props.clientPortal.id);
      uploadLoading.value = false;
      if (!clientPortalBackgroundData.uploadError) {
        clientPortalBackgroundData.dialogForBackground = false;
        emit("refresh-preview");
      }
    };

    return {
      uploadBackground,
      openDeleteDialog,
      triggerRemoveBackground,
      closeDeleteDialog,
      hasResource,
      ...toRefs(clientPortalBackgroundData),
      triggerUploadBackground,
      loading,
      errorMessage,
      uploadLoading,
      isGrantedUser,
      isFormValid,
    };
  },
};
</script>
